import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const mapStyles = [
  {
    featureType: 'road',
    stylers: [ { visibility: 'on' } ]
  },
  {
    featureType: 'transit',
    stylers: [ { visibility: 'on' } ]
  },
  {
    featureType: 'poi',
    stylers: [ { visibility: 'off' } ]
  },
  {
    featureType: 'poi.park',
    stylers: [ { visibility: 'on' } ]
  },
  {
    featureType: 'poi.park',
    stylers: [ { color: '#F9BD9A' } ]
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [ { color: '#000' } ]
  },
  {
    featureType: 'landscape',
    stylers: [{color: '#000'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [ { visibility: 'off' } ]
  },
  {
    featureType: 'water',
    stylers: [ { color: '#effdfd' } ]
  },
  {
    featureType: 'water',
    elementType: 'labels',
    styles: [ { visibility: 'off' } ]
  }
];


const FoodSlutMap = withScriptjs(withGoogleMap(props => {
  const {lat, lng} = props
  return (
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat: lat , lng: lng }}
      defaultOptions={{ styles: mapStyles }}
    >
       <Marker
        key={1}
        position={{ lat: lat , lng: lng }}
      />

    </GoogleMap>
  );
}));

export default FoodSlutMap;